(function () {
    'use strict';
    angular.module('app').controller('setDocumentWorkflow', setDocumentWorkflow);
    setDocumentWorkflow.$inject = ['$timeout', '$scope', '$rootScope', 'gridDataService', '$q', 'SelectionCommand_WorkflowService', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService'];
    function setDocumentWorkflow($timeout, scope, $rootScope, gridDataService, $q, SelectionCommand_WorkflowService, $mdDialog, records, command, commandService, loginService, editEmailsService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        // PL-OBS? scope.setDocumentWorkflowDialogShown = false;
        scope.ACN_SET_DEFAULT_WORKFLOW = 133;
        scope.xyz = { bReadyForOK: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // PL-OBS?
        //scope.$on('setDocumentWorkflowButtonClicked', function (event, arg) {
        //    scope.onSetDocumentWorkflowButtonClicked(arg.slx);
        //});

        // =====================================
        // On Load. Workflows.
        // =====================================
        // Set the combo to 'building list'.
        scope.qualifiedWorkflowsArrayLoading = function () {
            // If already on the 'building list', just leave it.
            if (scope.xyz.selectedWorkflowItem != scope.qualifiedWorkflowsBuildingList) {
                // Clear the array.
                scope.qualifiedWorkflowsArray = [];
                // Add 'building list' to the array.
                scope.qualifiedWorkflowsArray.push(scope.qualifiedWorkflowsBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedWorkflowItem = scope.qualifiedWorkflowsBuildingList;
                // We are waiting for the items.
                scope.xyz.gettingWorkflowList = true;
            }
        };
        // Load items into the combo. May be null.
        scope.qualifiedWorkflowsArrayLoad = function (workflows) {
            // Clear the array.
            scope.qualifiedWorkflowsArray = [];
            // Add 'pick one'.
            scope.qualifiedWorkflowsArray.push(scope.qualifiedWorkflowsPickOne);
            // Select 'pick one'.
            scope.xyz.selectedWorkflowItem = scope.qualifiedWorkflowsPickOne;
            // Add ''.
            scope.qualifiedWorkflowsArray.push(scope.qualifiedWorkflowsBlank);
            // If there are items, ...
            if (workflows != null) {
                // Walk the items, ...
                angular.forEach(workflows, function (name, id) {
                    // Add the item to the array.
                    scope.qualifiedWorkflowsArray.push({ id: id, name: name })
                });
            }
            // We are done getting the items.
            scope.xyz.gettingWorkflowList = false;
        }
        // Create a 'building list' item.
        scope.qualifiedWorkflowsBuildingList = { id: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Create a 'pick one' item.
        scope.qualifiedWorkflowsPickOne = { id: 'pick_one', name: "- " + loginService.resourceStrings["COMBO_BOX_PICK_ONE"] + " -" };
        // Create a '' item.
        scope.qualifiedWorkflowsBlank = { id: '', name: '' };
        // Initailize to the 'building list' state.
        scope.qualifiedWorkflowsArrayLoading();

        // =====================================
        //
        // =====================================  

        //
        // On step change.
        //
        scope.selectedWorkflowChanged = function () {
            // If nothing selected, then return.
            if (scope.xyz.selectedWorkflowItem == null)
                return;
            // If user selected 'pick one', then return.
            if (scope.xyz.selectedWorkflowItem == scope.qualifiedWorkflowsPickOne)
                return;

            var nameForGrid = scope.xyz.selectedWorkflowItem.name;
            // EDGE-EMPTY
            if (scope.xyz.selectedWorkflowItem.name.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.selectedWorkflowItem.name = '\u00A0';
                    nameForGrid = '\u00A0';
                }
            }

            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                gridItem.workflowId = scope.xyz.selectedWorkflowItem.id;
                gridItem.workflow = nameForGrid; // scope.xyz.selectedWorkflowItem.name;
                gridItem.selectionItem.commandParams.eWorkflowId = scope.xyz.selectedWorkflowItem.id; // *****
            });

            // Do Enables.
            scope.doEnables();
        };

        //
        // Enables.
        //
        scope.doEnables = function () {
            // Does every row have a workflow?
            var bAllHaveTarget = true;

            // ***** For enable logic, consider all rows.
            angular.forEach(scope.gridOptions.data, function (gridItem) {
                if (gridItem.workflowId.length < 1)
                    bAllHaveTarget = false;
            });

            // Handle enabling OK.
            scope.xyz.bReadyForOK = bAllHaveTarget;
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {

            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });

            // Get the selected items.
            var items = [];
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                item.isSelected = true;
                items.push(item.selectionItem);
            });

            // The main list.
            //var items = scope.gridApi.selection.getSelectedRows();

            // Build the SL with mode and order.
            var slx = { mode: 0, order: 0, list: items };

            // ============================
            // Select Item. Workflows.
            // ===========================+
            // Add users to the combo.
            scope.qualifiedWorkflowsArrayLoading();
            if (items.length < 1) {
                scope.qualifiedWorkflowsArrayLoad();
            }
            else {
                SelectionCommand_WorkflowService.GetWorkflowListForWorkflowCommand(slx, scope.mode).then(function (response) {
                    scope.qualifiedWorkflowsArrayLoad(response.data);
                }, function () {
                    scope.qualifiedWorkflowsArrayLoad();
                });
            }

            // Do Enables.
            scope.doEnables();
        };

        // On click of the Set Document Workflow button.
        scope.onSetDocumentWorkflowButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_SET_DEFAULT_WORKFLOW;
            scope.xyz = { bReadyForOK: false, selectedWorkflowItem: {} };

            // dialog config
            scope.heading = loginService.resourceStrings["SET_DOCUMENT_WORKFLOW"]; // "Set Document Workflow";
            scope.selectWorkflowLabel = loginService.resourceStrings["SELECT_WORKFLOW"]; // "Select Workflow";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_SET_DOCUMENT_WORKFLOW"]; // "Set Document Workflow on these Files:";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // For each selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(scope.slx.list, function (item) {
                // Add item.
                scope.gridOptions.data.push({
                    index: index,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename, library: item.detailedInfo.libName,
                    activeWorkflowName: item.detailedInfo.activeWorkflowName, activeStepName: item.detailedInfo.activeStepName,
                    workflow: '', workflowId: ''
                });
                index++;
            });

            // Enables.
            scope.selectItem();
            // Do modal.
            scope.setDocumentWorkflowDialogShown = true;
            $timeout(function () {
                refreshGrid();
                scope.gridApi.selection.selectAllRows();
                $timeout(function () {
                    refreshGrid();
                }, 2000);
            }, 500);
        };

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            var colActiveWorkflow = loginService.resourceStrings["SCHEMA_S_WFNAME"];
            var colActiveStep = loginService.resourceStrings["SCHEMA_S_STEPNAME"];
            var colWorkflow = loginService.resourceStrings["WORKFLOW"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
            scope.gridOptions.columnDefs[2].name = colActiveWorkflow;
            scope.gridOptions.columnDefs[3].name = colActiveStep;
            scope.gridOptions.columnDefs[4].name = colWorkflow;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onSetDocumentWorkflowDialogOK = function () {
            scope.xyz.processing = true;
            // Execute.
            SelectionCommand_WorkflowService.SetDocumentWorkflow(scope.slx).then(function (response) {
                // Handle errors.
                var atLeastOneError = false;
                var selectionCommandResults = response.data;
                var slx = selectionCommandResults.slx;
                angular.forEach(slx.list, function (item) {
                    if (atLeastOneError == false) {
                        if (item.ec != 0) {
                            atLeastOneError = true;
                            if (atLeastOneError) {
                                commandService.launchErrors({ slx: slx });
                            }
                        }
                    }
                });
                $mdDialog.hide();
                scope.xyz.processing = false;
                gridDataService.updateGridRecords(slx.list);

                editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
            });
        };

        scope.onSetDocumentWorkflowDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.setDocumentWorkflowDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);

            switch (command) {
                case "setdocumentworkflow":
                    scope.onSetDocumentWorkflowButtonClicked(records);
                    break;
            }

        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'FileName', field: 'name', width: '20%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '20%', minWidth: '100' },
                { name: 'Active Workflow', field: 'activeWorkflowName', width: '20%', minWidth: '100' },
                { name: 'Active Step', field: 'activeStepName', width: '20%', minWidth: '100' },
                { name: 'Workflow', field: 'workflow', width: '20%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
